import View from '@/base/views/view';

class HealthFail extends View {
    
    static table = 'healthfail';

    static async getTableOptions () {
        let res = await super.getTableOptions(this.options());
        const customerField = res.fields.find(f => f.name === 'CustomId')
        if (customerField) {
            customerField.label = 'Customer'
            customerField.relation = 'customer'
            customerField.optionLabels = 'Name'
            customerField.editor = 'vue-select'
            customerField.filters = (r) => {return r.Project.Name == 'Nubbo'}
        }
        const createdAtField = res.fields.find(f => f.name === 'CreatedUTC')
        if (createdAtField) {
            createdAtField.label = 'Fecha'
            createdAtField.hide = false
            createdAtField.hidden = false
            createdAtField.hideFromList = false
        }
        res.canAdd = false;
        return res;
    }

}

export default HealthFail;